import * as Core from '@skylab-shared/core';
import { SaleDocumentKind } from '../sale/sale-document-kind';

export class OrderKindModel extends Core.ModelBase {
	@Core.Property({ identifiable: true })
	public name: SaleDocumentKind;

	@Core.Property()
	public defaultDocumentToIssue: SaleDocumentKind;

	@Core.Property()
	public defaultVatRateId: number;
}
